import { FC } from "react";
import styles from "./PreviewTableImage.module.scss";
import defaultImg from "./assets/defaultImg.png";
import { Tooltip } from "antd";
import clsx from "clsx";

interface PreviewTableImageProps {
  isUsersPage?: boolean;
  src: string | null | undefined;
  isSmall?: boolean;
  isBig?: boolean;
}

export const PreviewTableImage: FC<PreviewTableImageProps> = ({
  isUsersPage = false,
  src = "",
  isSmall = false,
  isBig = false,
}) => {
  const content = src ? (
    <img
      className={styles.tooltipImg}
      src={src + "?type=detail"}
      alt={"image"}
    />
  ) : (
    ""
  );

  if (isUsersPage) {
    return <div>users</div>;
  } else {
    return (
      <div
        className={clsx(styles.previewMain, {
          [styles.smallSize]: isSmall,
          [styles.bigSize]: isBig,
        })}
      >
        {src ? (
          <Tooltip
            placement="rightTop"
            title={content}
            overlayClassName={styles.imgPreview}
            arrow={false}
            color="white"
          >
            <img src={src + "?type=preview"} alt="img" />
          </Tooltip>
        ) : (
          <img src={defaultImg} alt="load" />
        )}
      </div>
    );
  }
};
